let labels: Record<string, string> = {
  fb: 'Facebook',
  facebook: 'Facebook',
  ig: 'Instagram',
  instagram: 'Instagram',
  yt: 'YouTube',
  youtube: 'YouTube',
  tt: 'TikTok',
  tiktok: 'TikTok',
  twitter: 'Twitter',
  x: 'X',
}

let E: Record<string, any> = {}
export default E

E.platform_lbl = (platform: string): string => {
  if (!platform)
    return ''
  return labels[platform.toLowerCase()]
    || platform.charAt(0).toUpperCase() + platform.slice(1)
}


E.payout_est = (s: {med_views?: number, avg_views?: number,
  cpm?: number}): number => {
  let views = s.med_views ?? s.avg_views ?? 0
  return views/1000*(s.cpm || 0)
}

type Tiers = Record<string, {enabled?: boolean, payment?: number}|undefined>;


E.cps_list = (tiers?: Tiers): number[]=>{
  return Object.values(tiers || {})
    .filter(t=>t?.enabled && +(t.payment||0) > 0)
    .map(t=>+(t?.payment||0));
};

E.cps_lbl = (tiers?: Tiers): string=>{
  let list: number[] = E.cps_list(tiers);
  if (!list.length)
    return '-';
  let min = Math.min(...list), max = Math.max(...list);
  if (min == max)
    return '$'+min.toLocaleString();
  return '$'+min.toLocaleString()+'–$'+max.toLocaleString();
};


E.spons_est = (budget: number, tiers?: Tiers): number=>{
  let list: number[] = E.cps_list(tiers);
  if (!list.length || !budget)
    return 0;
  let avg = list.reduce((a, b)=>a+b, 0)/list.length;
  return Math.floor(budget/avg);
};